<script setup>
import { computed } from "vue";
import { useMainStore } from "@/store/MainStore.js";
import { useRoute } from "vue-router";
import Breadcrumbs from "../Dashboard/Breadcrumbs.vue";
import { useAuthStore } from "@/store/AuthStore";
import Notifications from "@/components/Dashboard/Notifications.vue";

const store = useMainStore();
const authStore = useAuthStore();
const darkMode = computed(() => store.darkMode);

const route = useRoute();

const isAuthenticated = computed(() => authStore.isAuthenticated);
const userName = computed(() => authStore.getUser?.full_name);

const currentRouteName = computed(() => {
  return route.name;
});
const currentDirectory = computed(() => {
  let dir = route.path.split("/")[1];
  return dir.charAt(0).toUpperCase() + dir.slice(1);
});

const minimizeSidebar = () => store.sidebarMinimize();
// const toggleConfigurator = () => store.commit("toggleConfigurator");

// const closeUserMenu = () => {
//   setTimeout(() => {
//     store.closeTopnavMenu();
//   }, 120);
// };
const toggleUserMenu = () => store.setTopnavOpenMenu('user');

const isUserMenuOpen = computed(() => store.topnavOpenMenu === 'user');

</script>
<template>
  <nav
      class="navbar navbar-main navbar-expand-lg px-0 shadow-none border-radius-xl"
      v-bind="$attrs"
      id="navbarBlur"
      data-scroll="true"
  >
    <div class="px-3 py-1 container-fluid">
      <div class="d-flex align-items-center gap-3 flex-wrap">
<!--        <div class="brand-chip">-->
<!--          <img :src="logoGray" alt="Calid" />-->
<!--        </div>-->
        <breadcrumbs
          :current-page="currentRouteName"
          :current-directory="currentDirectory"
        />
      </div>
      <div
        class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        id="navbar"
      >
        <div
          class="pe-md-3 d-flex align-items-center ms-md-auto"
        >
        </div>
        <ul class="navbar-nav justify-content-end">

           <li class="nav-item dropdown d-flex align-items-center">
            <a
                href="#"
                class="px-0 nav-link font-weight-bold opacity-8 user-menu-trigger"
                :class="[isUserMenuOpen ? 'show is-open' : '', darkMode ? 'text-white' : 'text-dark']"
                v-if="isAuthenticated"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
                @click.stop="toggleUserMenu"
                id="userDropdownBtn"
            >

              <span class="avatar-chip">
                <i class="fa fa-user" aria-hidden="true"></i>
              </span>
              <span class="d-sm-inline d-none">{{ userName }}</span>
            </a>
            <router-link
              v-else
              :to="{ name: 'Signin' }"
              class="px-0 nav-link font-weight-bold"
              :class="darkMode ? 'text-white' : 'text-dark'"
            >
              <i class="fa fa-user me-sm-2"></i>
              <span class="d-sm-inline d-none">Sign In</span>
            </router-link>
            <ul
                class="px-1 py-3 dropdown-menu dropdown-menu-end me-sm-n4"
                :class="['user-dropdown', isUserMenuOpen ? 'show' : '']"
                aria-labelledby="userDropdownBtn"
                data-bs-auto-close="outside"
            >
              <li class="menu-header d-flex align-items-center justify-content-between px-2">
                <div class="d-flex align-items-center gap-2">
                  <span class="avatar-chip small"><i class="fa fa-user"></i></span>
                  <div class="d-flex flex-column">
                    <span class="fw-semibold">{{ userName }}</span>
                    <small class="text-muted">Signed in</small>
                  </div>
                </div>
              </li>
              <li><hr class="dropdown-divider"/></li>
              <li class="mb-1">
                <router-link to="/account" class="dropdown-item border-radius-md ">
                  <div class="py-1 d-flex align-items-center gap-3">
                    <i class="fa fa-user text-info"></i>
                    <span>Account</span>
                  </div>
                </router-link>
              </li>
              <li>
                <router-link to="/logout" class="dropdown-item border-radius-md">
                  <div class="py-1 d-flex align-items-center gap-3 text-danger">
                    <i class="fa fa-sign-out"></i>
                    <span>Log Out</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="px-2 nav-item d-flex align-items-center" style="display: none;">

          </li>
          <Notifications />
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a
                href="#"
                @click="minimizeSidebar"
                class="p-0 nav-link"
                :class="darkMode ? 'text-white' : 'text-dark'"
                id="iconNavbarSidenav"
            >
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line"
                   :class="darkMode ? 'bg-white' : 'bg-dark'"></i>
                <i class="sidenav-toggler-line"
                   :class="darkMode ? 'bg-white' : 'bg-dark'"></i>
                <i class="sidenav-toggler-line"
                   :class="darkMode ? 'bg-white' : 'bg-dark'"></i>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<style scoped>
.brand-chip {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  height: 40px;
}
:root:not(.dark-version) .brand-chip {
  background: #f9fafb;
  border-color: #e5e7eb;
}
.brand-chip img {
  height: 20px;
  width: auto;
  display: block;
}

.user-dropdown {
  min-width: 220px;
  border-radius: 14px;
  border: 1px solid var(--calid-border, rgba(255,255,255,0.08));
  background: var(--calid-card-bg, rgba(17,24,39,0.96));
  box-shadow: 0 22px 50px rgba(0,0,0,0.35);
  backdrop-filter: blur(10px);
}

.user-menu-trigger.is-open {
  background: rgba(14, 165, 233, 0.1);
  border-radius: 10px;
  box-shadow: 0 6px 16px rgba(14, 165, 233, 0.22);
}

.avatar-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(59,130,246,0.16);
  color: #60a5fa;
}

.avatar-chip.small {
  width: 30px;
  height: 30px;
  font-size: 0.85rem;
}

.menu-header {
  color: var(--calid-text-primary, #f0f0f5);
  padding-bottom: 0.35rem;
}

:root:not(.dark-version) .user-dropdown {
  background: #fff;
  border-color: #e5e7eb;
  box-shadow: 0 22px 40px rgba(0,0,0,0.12);
}
</style>
